var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdviceInfo = function SvgAdviceInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12a7 7 0 1 0 14 0 7 7 0 0 0-14 0Zm7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.241a.7.7 0 0 1 .7.7V16.3a.7.7 0 1 1-1.4 0v-5.359a.7.7 0 0 1 .7-.7Zm0-1.524a.7.7 0 0 1-.7-.7V8a.7.7 0 1 1 1.4 0v.017a.7.7 0 0 1-.7.7Z",
    fill: "currentColor"
  })));
};
export { SvgAdviceInfo as ReactComponent };
export default __webpack_public_path__ + "c25b7ce90162a43dd4da1806f82e2c52.svg";